module.exports = __webpack_public_path__ + "static/media/graphql.5a4a847b.svg";